<template>
  <div class="autocomplete-search-container">
    <el-autocomplete
      v-model="searchQuery"
      :fetch-suggestions="fetchSuggestions"
      placeholder="Search site..."
      @select="handleSelect"
      :trigger-on-focus="false"
      clearable
      class="w-100 site-search-autocomplete"
      popper-class="site-search-popper"
    >
      <template #prepend>
        <el-icon><Search /></el-icon>
      </template>
      <template #default="props">
        <div v-if="props && props.item" class="suggestion-item">
          <span class="value">{{ props.item.value }}</span>
          <span class="category-tag">{{ props.item.category }}</span>
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import { Search } from '@element-plus/icons-vue'; // Import icon

const searchQuery = ref('');
let debounceTimeout = null;

const fetchSuggestions = (queryString, cb) => {
  if (queryString && queryString.length >= 2) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(async () => {
      try {
        const response = await axios.get('/autocomplete/search', {
          params: { query: queryString }
        });
        cb(response.data);
      } catch (error) {
        console.error('Error fetching search suggestions:', error);
        cb([]);
      }
    }, 300); // 300ms debounce
  } else {
    cb([]);
  }
};

const handleSelect = (item) => {
  if (item && item.link) {
    window.location.href = item.link;
  }
};
</script>

<style>
.autocomplete-search-container {
  min-width: 250px; /* Adjust as needed */
  width: 100%;
}

.site-search-autocomplete .el-input-group__prepend {
  padding: 0 8px; /* Reduced padding for spyglass */
}

.site-search-autocomplete .el-input__inner {
  height: 38px; /* Match header item height */
}

/* Ensure popper is wider if needed and has higher z-index */
.site-search-popper {
  min-width: 300px; /* Or match input width */
  z-index: 2050 !important; /* Ensure it's above other header elements */
}

.suggestion-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0; /* Slightly increased padding */
  line-height: 1.5;
}

.suggestion-item .category-tag {
  font-size: 0.75rem; /* Slightly increased font size */
  font-weight: bold;
  color: #fff;
  background-color: #74bfff; /* A blue shade, adjust as needed */
  padding: 3px 7px; /* Slightly increased padding */
  border-radius: 4px;
  margin-left: 10px; /* Switched from margin-right */
  white-space: nowrap;
  order: 1; /* Ensure it comes after the value if DOM order is different */
}

.suggestion-item .value {
  font-size: 0.9rem; /* Increased font size */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  text-align: left;
}
</style>
